import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';

export default function AlertDialog(props) {
  return (
    <div>
      <Dialog
        open={props.state.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">{"Confirmação de ação"}</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.state.mensagem}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.props.state.itemEscolhido &&
            <div>
              <Button onClick={props.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={props.handleConfirm} color="primary" autoFocus>
                Confirmar
              </Button>
            </div>
          }
          {!props.props.state.itemEscolhido &&
            <div>
              <Button onClick={props.handleClose} color="primary">
                Ok
              </Button>
            </div>
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}